<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('vip.menu.unitPrice')" prop="unitPrice">
                <a-input-number :min="0" :step="0.01" :precision="2" v-model="queryParam.unitPrice" allow-clear :placeholder="$t('vip.menu.inputUnitPrice')" style="width: 100%" />
              </a-form-item>
            </a-col>
            <!--            <a-col :md="5" :sm="24">-->
            <!--              <a-form-item label="ios内购产品id" prop="productId">-->
            <!--                <a-input v-model="queryParam.productId" placeholder="请输入ios内购产品id" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('vip.menu.totalPrice')" prop="totalPrice">
                <a-input-number :min="0" :step="0.01" :precision="2" v-model="queryParam.totalPrice" allow-clear :placeholder="$t('vip.menu.inputTotalPrice')" style="width: 100%" />
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery()"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['vip:menu:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['vip:menu:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['vip:menu:remove']">-->
        <!--          <a-icon type="delete" />删除-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['vip:menu:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1300 }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <!--        <span slot="isOpen" slot-scope="text, record">-->
        <!--          &lt;!&ndash; <dict-tag :options="dict.type['sys_show_hide']" :value="record.status" /> &ndash;&gt;-->
        <!--          <a-popconfirm ok-text="是" cancel-text="否" @confirm="editIsopen(record)"-->
        <!--                        @cancel="cancelHandleStatus(record)">-->
        <!--            <span slot="title">确认<b>{{ record.status === 0 ? '关闭' : '开启' }}</b>吗?</span>-->
        <!--            <a-switch checked-children="开" un-checked-children="关" :checked="record.status === 0" />-->
        <!--          </a-popconfirm>-->

        <span slot="isOpen" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.enable')" :unCheckedChildren="$t('common.disable')" v-model="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
        </span>



        <span slot="operation" slot-scope="text, record">
          <!-- v-hasPermi="['vip:menu:edit']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['vip:menu:edit']" -->
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <!--          <a-divider type="vertical" v-hasPermi="['vip:menu:remove']" />-->
          <!--          <a @click="handleDelete(record)" v-hasPermi="['vip:menu:remove']">-->
          <!--            <a-icon type="delete" />删除-->
          <!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMenu,listMenu, delMenu,changeIsOpen } from '@/api/vip/menu'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Menu',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: null,
        unitPrice: null,
        productId: null,
        totalPrice: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('vip.menu.type'),
          dataIndex: 'type',
          width: 120,
          align: 'center',
          customRender: (t, r, index) => {
            if(t == 0) {
              return this.$t('vip.menu.typeWeek')
            }else if(t == 1) {
              return this.$t('vip.menu.typeMonth')
            }else if(t == 2) {
              return this.$t('vip.menu.typeYear')
            }
            return t
          }
        },
        {
          title: this.$t('system.status'),
          dataIndex: 'isOpen',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'isOpen' },
        },
        {
          title: this.$t('vip.menu.unitPrice'),
          dataIndex: 'unitPrice',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('vip.menu.remark'),
          dataIndex: this.$i18n.locale === 'en-US' ? 'remarkEn' : 'remarkIn',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('vip.menu.totalPrice'),
          dataIndex: 'totalPrice',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('system.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    /** 查询会员菜单列表 */
    getList () {
      this.loading = true
      pageMenu(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeIsOpen (e,record) {
      record.isOpen = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          this.$t('vip.menu.operationSuccess')
        )
        return  record.isOpen = e ? 1 : 0
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        unitPrice: undefined,
        productId: undefined,
        totalPrice: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMenu(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('vip/vip-menu/export', {
            ...that.queryParam
          }, `${that.$t('vip.menu.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }

  },


}
</script>
